import React, { PureComponent } from 'react'
import styled, { keyframes } from 'styled-components'
import { Map } from 'immutable'
import { TaskState } from '@src/editor-helpers'
import Balloon from '@components/Balloon'
import { ContentBlock, EditorState } from 'draft-js'
import Parser from 'ua-parser-js'

type Props = {
  block: ContentBlock
  blockProps: {
    getEditorState: () => EditorState
    changeDecision: (block: ContentBlock, newBlock: ContentBlock) => void
  }
}

const parser = new Parser()
const os = parser.getOS()

const keyModificatorSymbol = os.name === 'Mac OS' ? '^' : 'Ctrl+'

class DecisionBlock extends PureComponent<Props> {
  onPressButton = (event: React.MouseEvent<HTMLButtonElement>) => {
    const {
      block,
      blockProps: { changeDecision }
    } = this.props

    let data
    const existData = block.get('data').toJS()
    const target = event.target as HTMLElement
    if (existData.selected && existData.selected === target.dataset.name) {
      data = {
        ...existData,
        selected: null
      }
    } else {
      data = {
        ...existData,
        selected: target.dataset.name
      }
    }

    const newBlock = block.merge({
      data: Map(data)
    }) as ContentBlock
    changeDecision(block, newBlock)
  }
  render() {
    const {
      block,
      blockProps: { getEditorState }
    } = this.props
    const editorState = getEditorState()
    const data = block.get('data').toJS()
    const selected = data.selected ? data.selected : null
    const taskState = TaskState.fromEditorState(editorState)
    const currentTask = TaskState.getTaskByKey(taskState, block.get('key'))
    const isFirstTask = currentTask === taskState[0]

    return (
      <ButtonGroup data-draftjs-block-key={block.get('key')}>
        <Button onClick={this.onPressButton} className={selected === 'do' ? 'selected' : ''} data-name="do">
          {`Делаем ${keyModificatorSymbol}D`}
        </Button>
        <Button onClick={this.onPressButton} className={selected === 'dontdo' ? 'selected' : ''} data-name="dontdo">
          {`Не делаем ${keyModificatorSymbol}R`}
        </Button>
        <Button onClick={this.onPressButton} className={selected === 'timeout' ? 'selected' : ''} data-name="timeout">
          {`Берём таймаут ${keyModificatorSymbol}T`}
        </Button>
        {isFirstTask && <Balloon />}
      </ButtonGroup>
    )
  }
}

const show = keyframes`
  from {
    opacity: 0;
  }

  to {
    opacity: 1;
  }
`

const ButtonGroup = styled.div`
  animation: ${show} 0.2s linear;
  margin-top: 0.9em;
  padding-bottom: 3em;
`

const Button = styled.button`
  background-color: #fff;
  border-radius: 2px;
  border: 1px solid #deddda;
  color: #aba8a1;
  cursor: pointer;
  font-size: 0.8em;
  line-height: 1.06em;
  outline: none;
  padding: 0.25em 1em 0.3em;
  user-select: none;

  &:not(:last-child) {
    margin-right: 1em;
  }

  &:hover {
    color: #fe5353;
    border-color: #deddda;
  }

  &.selected {
    background-color: #ccdff4;
    border-color: #ccdff4;
    color: #000;
  }
`
export default DecisionBlock



// WEBPACK FOOTER //
// ./src/components/DecisionBlock/DecisionBlock.tsx